function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["addonsProps", "after", "afterProps", "before", "beforeProps", "bodyProps", "className", "disabled", "error", "errorProps", "headerProps", "helpText", "helpTextProps", "id", "innerProps", "label", "labelPosition", "labelProps", "leftIcon", "leftIconProps", "look", "max", "maxLength", "min", "minLength", "name", "onBlur", "onChange", "pattern", "placeholder", "readOnly", "required", "requiredLabel", "rightIcon", "rightIconProps", "showLabel", "textfieldProps", "type", "value", "wrapperRef"],
  _excluded2 = ["labelPosition", "look", "showLabel", "type"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import { baseInputStyle, getInputBorderRadius, getInputPadding, getInputTheme } from "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import { TextfieldBody } from "../../../internal/textfield/textfield-body.js";
import { TextfieldHeader } from "../../../internal/textfield/textfield-header.js";
import { TextfieldIcon, TextfieldIconTypes } from "../../../internal/textfield/textfield-icon.js";
import { TextfieldInner } from "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { BaseTextfield } from "../base-textfield/base-textfield.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardTextfield = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var addonsProps = props.addonsProps,
    after = props.after,
    afterProps = props.afterProps,
    before = props.before,
    beforeProps = props.beforeProps,
    bodyProps = props.bodyProps,
    className = props.className,
    disabled = props.disabled,
    error = props.error,
    errorProps = props.errorProps,
    headerProps = props.headerProps,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    id = props.id,
    innerProps = props.innerProps,
    label = props.label,
    labelPosition = props.labelPosition,
    labelProps = props.labelProps,
    leftIcon = props.leftIcon,
    leftIconProps = props.leftIconProps,
    look = props.look,
    max = props.max,
    maxLength = props.maxLength,
    min = props.min,
    minLength = props.minLength,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    pattern = props.pattern,
    placeholder = props.placeholder,
    readOnly = props.readOnly,
    required = props.required,
    requiredLabel = props.requiredLabel,
    rightIcon = props.rightIcon,
    rightIconProps = props.rightIconProps,
    showLabel = props.showLabel,
    textfieldProps = props.textfieldProps,
    type = props.type,
    value = props.value,
    wrapperRef = props.wrapperRef,
    otherProps = _objectWithoutProperties(props, _excluded);
  var hasAfter = !!after;
  var hasBefore = !!before;
  var hasError = !!error;
  var hasHelpText = !!helpText;
  var hasLeftIcon = !!leftIcon;
  var hasRequired = required && !!requiredLabel;
  var hasRightIcon = !!rightIcon;
  var helpTextId = "".concat(id, "-help-text");
  var inlineAlertId = "".concat(id, "-inline-alert");
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-textfield__standard': true,
      'bf-textfield__standard--after': hasAfter,
      'bf-textfield__standard--before': hasBefore,
      'bf-textfield__standard--disabled': disabled,
      'bf-textfield__standard--error': hasError,
      'bf-textfield__standard--help-text': hasHelpText
    }, _defineProperty(_classnames, "bf-textfield__standard--label-".concat(labelPosition), showLabel), _defineProperty(_classnames, 'bf-textfield__standard--label-hidden', !showLabel), _defineProperty(_classnames, 'bf-textfield__standard--left-icon', hasLeftIcon), _defineProperty(_classnames, "bf-textfield__standard--look-".concat(look), look), _defineProperty(_classnames, 'bf-textfield__standard--placeholder', !!placeholder), _defineProperty(_classnames, 'bf-textfield__standard--readonly', readOnly), _defineProperty(_classnames, 'bf-textfield__standard--required', hasRequired), _defineProperty(_classnames, 'bf-textfield__standard--right-icon', hasRightIcon), _defineProperty(_classnames, "bf-textfield__standard--type-".concat(type), type), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    labelPosition: labelPosition,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(TextfieldHeader, _extends({}, headerProps, {
    error: error,
    errorProps: errorProps,
    htmlFor: id,
    inlineAlertId: inlineAlertId,
    label: label,
    labelPosition: labelPosition,
    labelProps: labelProps,
    required: required,
    requiredLabel: requiredLabel,
    showLabel: showLabel
  })), /*#__PURE__*/React.createElement(TextfieldBody, _extends({}, bodyProps, {
    addonsProps: addonsProps,
    after: after,
    afterProps: afterProps,
    before: before,
    beforeProps: beforeProps,
    disabled: disabled,
    error: error,
    errorProps: errorProps,
    helpText: helpText,
    helpTextId: helpTextId,
    helpTextProps: helpTextProps,
    inlineAlertId: inlineAlertId,
    labelPosition: labelPosition,
    look: look
  }), /*#__PURE__*/React.createElement(TextfieldInner, _extends({}, innerProps), hasLeftIcon && /*#__PURE__*/React.createElement(TextfieldIcon, _extends({}, leftIconProps, {
    disabled: disabled,
    error: error,
    icon: leftIcon,
    look: look,
    type: TextfieldIconTypes.Left
  })), /*#__PURE__*/React.createElement(BaseTextfield, _extends({}, textfieldProps, {
    "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
    "aria-disabled": disabled,
    "aria-invalid": hasError,
    className: classnames(_defineProperty({
      'bf-textfield__textfield': true
    }, "".concat(textfieldProps === null || textfieldProps === void 0 ? void 0 : textfieldProps.className), !!(textfieldProps !== null && textfieldProps !== void 0 && textfieldProps.className))),
    disabled: disabled,
    id: id,
    max: max,
    maxLength: maxLength,
    min: min,
    minLength: minLength,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    pattern: pattern,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    required: required,
    type: type,
    value: value
  })), hasRightIcon && /*#__PURE__*/React.createElement(TextfieldIcon, _extends({}, rightIconProps, {
    disabled: disabled,
    error: error,
    icon: rightIcon,
    look: look,
    type: TextfieldIconTypes.Right
  })))));
});
var Textfield = styled(BaseStandardTextfield)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .bf-textfield__textfield {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"])), baseInputStyle, function (_ref) {
  var after = _ref.after,
    before = _ref.before;
  return getInputBorderRadius({
    after: after,
    before: before
  });
}, function (_ref2) {
  var leftIcon = _ref2.leftIcon,
    rightIcon = _ref2.rightIcon;
  return getInputPadding({
    leftIcon: leftIcon,
    rightIcon: rightIcon
  });
}, function (_ref3) {
  var error = _ref3.error,
    look = _ref3.look;
  return getInputTheme({
    error: error,
    look: look
  });
});
/**
 * A `<input>` element, which allows single-line text editing.
 * Line-breaks are automatically removed from the input value.
 * `id` and `label` are required for accessibility.
 *
 * `<input>` allowed `type`'s are `email`, `number`, `password`, `search`, `tel`, `text`, and `url`.
 *
 * When `InputLabelPositions.Left`is set, apply a `width` or `max-width` on `.bf-textfield__header`.
 * See Textfield [examples](https://brandfolder.com/designsystem/?path=/docs/components-molecules-textfields--examples)
 * for recommended CSS styling.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/text
 *
 * @param props StandardTextfieldProps
 * @returns FunctionComponent<StandardTextfieldProps>
 */
var StandardTextfield = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Textfield, _extends({}, otherProps, {
    labelPosition: labelPosition,
    look: look,
    ref: ref,
    showLabel: showLabel,
    type: type
  })));
});
export { StandardTextfield };